import {types} from 'privates/utils';


/*
 * @enum {external:String}
 * @summary Types of elements that you can access using Wix Code.
 * @readonly
 */
const getTypes = () => types.possibleTypes;

export default getTypes;



// WEBPACK FOOTER //
// ./js/modules/ui/Types.es6